import React from 'react';
import { Minus, Plus, Trash2 } from 'lucide-react';
import { CartItem as CartItemType } from '../../lib/types';
import { formatCurrency } from '../../lib/utils';
interface CartItemProps {
  item: CartItemType;
  onUpdateQuantity: (id: string, quantity: number) => void;
  onRemove: (id: string) => void;
}
export function CartItem({
  item,
  onUpdateQuantity,
  onRemove
}: CartItemProps) {
  const optionsTotal = item.selected_options.reduce((sum, opt) => sum + opt.price_delta, 0);
  const unitPrice = item.unit_price_snapshot + optionsTotal;
  const lineTotal = unitPrice * item.quantity;
  return <div className="flex gap-3 py-4 border-b border-white/5 last:border-0" data-id="element-584">
      {/* Image if available */}
      {item.image_url && <div className="w-14 h-14 rounded-xl overflow-hidden bg-[#1a1a1a] shrink-0 border border-white/5" data-id="element-585">
          <img src={item.image_url} alt={item.item_name_snapshot} className="w-full h-full object-cover" data-id="element-586" />
        </div>}

      <div className="flex-1 flex flex-col min-w-0" data-id="element-587">
        <div className="flex justify-between items-start mb-0.5" data-id="element-588">
          <h4 className="font-semibold text-[#F8F5F0] text-sm leading-tight pr-2" data-id="element-589">
            {item.item_name_snapshot}
          </h4>
          <button onClick={() => onRemove(item.id)} className="text-[#F8F5F0]/30 hover:text-[#E63946] transition-colors p-1 -mr-1 shrink-0" aria-label="Eliminar producto" data-id="element-590">
            <Trash2 className="w-4 h-4" data-id="element-591" />
          </button>
        </div>

        {/* Options */}
        {item.selected_options.length > 0 && <ul className="text-xs text-[#F8F5F0]/50 mb-1.5 space-y-0.5" data-id="element-592">
            {item.selected_options.map((opt, idx) => <li key={idx} className="flex justify-between" data-id="element-593">
                <span className="truncate pr-2" data-id="element-594">• {opt.option_name}</span>
                {opt.price_delta > 0 && <span className="shrink-0" data-id="element-595">
                    +{formatCurrency(opt.price_delta)}
                  </span>}
              </li>)}
          </ul>}

        {/* Notes */}
        {item.notes && <p className="text-xs text-[#F4D35E] bg-[#F4D35E]/10 px-2 py-1 rounded-md mb-2 italic line-clamp-2" data-id="element-596">
            "{item.notes}"
          </p>}

        <div className="mt-auto flex items-center justify-between pt-1" data-id="element-597">
          {/* Quantity Controls */}
          <div className="flex items-center bg-[#1a1a1a] rounded-lg p-0.5 border border-white/10" data-id="element-598">
            <button onClick={() => onUpdateQuantity(item.id, item.quantity - 1)} className="w-7 h-7 flex items-center justify-center rounded-md hover:bg-[#2a2a2a] transition-all text-[#F8F5F0]/60 hover:text-[#F8F5F0]" data-id="element-599">
              <Minus className="w-3.5 h-3.5" data-id="element-600" />
            </button>
            <span className="w-7 text-center font-semibold text-sm text-[#F8F5F0]" data-id="element-601">
              {item.quantity}
            </span>
            <button onClick={() => onUpdateQuantity(item.id, item.quantity + 1)} className="w-7 h-7 flex items-center justify-center rounded-md hover:bg-[#2a2a2a] transition-all text-[#F8F5F0]/60 hover:text-[#F8F5F0]" data-id="element-602">
              <Plus className="w-3.5 h-3.5" data-id="element-603" />
            </button>
          </div>

          <div className="font-bold text-[#F4D35E] text-sm" data-id="element-604">
            {formatCurrency(lineTotal)}
          </div>
        </div>
      </div>
    </div>;
}